@if(positions.length) {
<button mat-icon-button type="button"
  class="btn-success tw-h-8 tw-w-8 tw-rounded-full tw-text-xs tw-font-semibold"
  [matBadge]="positions.length"
  [matBadgeHidden]="positions.length <= 1"
  matBadgeSize="small"
  [matMenuTriggerFor]="positionMenu"
  [attr.aria-label]="'Open live transfer queue positions for ' + positions.length + ' campaigns. Best current position ' + bestRank">
  #{{bestRank}}
</button>

<mat-menu #positionMenu="matMenu" class="w-fit-content">
  <div class="tw-w-[min(24rem,calc(100vw_-_2rem))] tw-p-4" aria-label="Live transfer queue positions">
    <div class="tg-section-title tw-mb-2">Live transfer queue</div>
    <div class="tw-flex tw-max-h-[min(24rem,calc(100vh_-_8rem))] tw-flex-col tw-gap-2 tw-overflow-y-auto">
    @for(position of positions; track position.campaignId) {
    <div class="tw-grid tw-grid-cols-[minmax(0,1fr)_auto] tw-items-center tw-gap-3 tw-text-sm">
      <span class="tw-break-words" [title]="position.campaignName">{{position.campaignName}}</span>
      <span class="uw-tag uw-tag-success tw-whitespace-nowrap">Position #{{position.rank}}</span>
    </div>
    }
    </div>
  </div>
</mat-menu>
}
